const contextMenu = {
  colors: "Цвета",
  backgroundColor: "Фон",
  textColor: "Текст",
  textHighlight: "Выделение",
  borderColor: "Граница",
  typography: "Типографика",
  fontFamily: "Шрифт",
  fontSize: "Размер",
  letterSpacing: "Межбуквенный интервал",
  lineHeight: "Высота строки",
  textContent: "Текстовое содержание",
  resetElement: "Сбросить элемент",
  resetAll: "Сбросить всё",
  openPicker: "Открыть палитру",
  transparent: "Прозрачный",
  overridesSection: "Стили элементов",
  overridesHint: "Правый клик на элемент для настройки",
  systemDefault: "По умолчанию",
  myCustom: "Пользовательское",
  nameHistory: "История названий",
  noHistory: "Нет истории",
  originalName: "Исходное название",
  restoreName: "Восстановить название",
} as const;
export default contextMenu;
